<template>
  <div class="rule-digital-edit-item">
    <div class="rule-oper-btn">
      <i class="el-icon-edit-outline" @click="showEditDigitalDialog(ruleDigitalItem)"></i>
      <i class="el-icon-delete" @click="delRuleDigital(ruleDigitalItem.digitalId)"></i>
      <!-- <i class="el-icon-sort"></i> -->
    </div>
    <div class="rule-name">
      <el-tooltip :disabled="ruleDigitalItem.ruleName.length <= 10" :content="ruleDigitalItem.ruleName" placement="top">
        <span>{{ ruleTypeItemIndex+1 }}.{{ruleDigitalItemIndex+1}} {{ ruleDigitalItem.ruleName }}</span>
      </el-tooltip>
    </div>
    <div class="rule-view-area">
      <template v-for="(contentItem, $index) in ruleDigitalItem.ruleContent">
        <template v-if="contentItem.type == 'images'">
          <el-input class="eb-input input-item" :key="ruleDigitalItem.ruleId + '_' + $index" :value="contentItem.content" readonly
            size="small"></el-input>
        </template>

        <template v-if="contentItem.type == 'text'">
          <el-input class="eb-input input-item" :key="ruleDigitalItem.ruleId + '_' + $index" :value="contentItem.content" readonly
            size="small"></el-input>
        </template>

        <template v-if="contentItem.type == 'radio'">
          <el-radio class="eb-radio" :name="'contentItem_' + ruleDigitalItem.ruleId" :key="ruleDigitalItem.ruleId + '_' + $index" :label="ruleDigitalItem.ruleId + '_' + $index">{{contentItem.content}}</el-radio>
        </template>

        <template v-if="contentItem.type == 'radioText'">
          <el-radio class="eb-radio" :name="'contentItem_' + ruleDigitalItem.ruleId" :key="ruleDigitalItem.ruleId + '_' + $index" :label="ruleDigitalItem.ruleId + '_' + $index">
            <el-input class="eb-input" v-model="contentItem.content" readonly size="small"></el-input>
          </el-radio>
        </template>

        <template v-if="contentItem.type == 'buyerfile'">
          <el-input class="eb-input input-item" :key="ruleDigitalItem.ruleId + '_' + $index + '_1'" :value="contentItem.content" readonly
            size="small"></el-input>
        </template>

        <template v-if="contentItem.type == 'supplierfile'">
          <el-input class="eb-input input-item" :key="ruleDigitalItem.ruleId + '_' + $index" :value="contentItem.content" readonly
            size="small"></el-input>
        </template>

        <template v-if="contentItem.type == 'text-detail'">
          <el-input class="eb-input input-item text-detail-input-item" :key="ruleDigitalItem.ruleId + '_' + $index" :value="contentItem.content"
            readonly size="small"></el-input>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import EventBus from '@/plugins/event-bus';
import { editDigital, delDigitalById } from '@/services/rule/rule-digital-service';

export default {
  inject: ['showEditDigitalDialog'],
  props: {
    ruleTypeItemIndex: {
      type: Number,
      required: true
    },
    ruleDigitalItem: {
      type: Object,
      required: true
    },
    ruleDigitalItemIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    async editRuleDigital() {
      try {
        let params = {};
        let { data } = await editDigital(params);
        if (data.returnCode === '01') {
        } else if (data.returnCode === '03') {
        } else {
          this.$message.error('新增规则失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    delRuleDigital(digitalId) {
      this.$ebConfirm('确认要删除该规则么?')
        .then(async () => {
          try {
            let { data } = await delDigitalById(digitalId);
            if (data.returnCode === '01') {
              this.$message.success('删除规则成功');
              EventBus.$emit('reloadRuleDigitalList');
            } else if (data.returnCode === '03') {
              this.$message.error('缺少参数');
            } else {
              this.$message.error('删除规则失败');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less">
.rule-digital-edit-item {
  line-height: 38px;
  display: flex; /*Flex布局*/
  display: -webkit-flex; /* Safari */
  align-items: baseline; /*指定基线居中*/

  .rule-oper-btn {
    display: inline-block;
    padding-right: 8px;
    line-height: 37px;
    font-size: 1.3em;
    i {
      font-weight: bold;
      cursor: pointer;
    }
  }

  /** 规则名称 **/
  .rule-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 232px;
    min-width: 232px;
    display: inline-block;
  }

  .rule-view-area {
    width: auto;

    /** 单选框 **/
    .eb-radio {
      margin-left: 0px;
      margin-right: 10px;
      .el-radio__label {
        padding-left: 5px;
      }
      .el-input__inner {
        width: 200px;
        border-radius: 0px;
      }
    }
  }
  /** 输入框 **/
  .input-item {
    height: 30px;
    width: 280px;
    .el-input__inner {
      border-radius: 0px;
    }
  }
  /** 信息显示 **/
  .text-detail-input-item {
    .el-input__inner {
      background: #efefef;
      border-color: #efefef;
      &:hover {
        background: #ffffff;
        border-color: #cecece;
      }
    }
  }
}
</style>
